var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"b-embed"},[_c('iframe',{attrs:{"src":_vm.data.url,"scrolling":"no","frameborder":"no"}})])}
var staticRenderFns = []

export { render, staticRenderFns }